<div style="display: flex;" data-cy="recent-patients-component">
  <div style="flex: 1; min-height: 200px; height: fit-content; max-height: 600px; margin-bottom: var(--margin-size);" data-cy="recent-patients-container">
    @if (isLoading) {
      <mat-spinner class="loading-spinner" [diameter]="50" data-cy="recent-patients-loading"></mat-spinner>
    }
    <div class="patient-cells" style="margin-top: 2px; margin-bottom: 4px; max-height: 600px;" data-cy="recent-patients-list">
      @for (appt of recentPatients; track appt) {
        <div class="patient-cell" style="cursor: pointer;" (click)="changePatient(appt)" data-cy="recent-patient-item-{{appt.patientId}}">
          <div style="display: flex;" data-cy="recent-patient-content">
            <div style="flex-basis: fit-content;" data-cy="recent-patient-image-container">
              <img [src]="appt.patientImageUrl | secureImage | async" [ngClass]="{'private-picture': !isPrivateInfoVisible}" style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid #cccccc;" data-cy="recent-patient-image">
            </div>
            <div style="flex: 1; color: black; line-height: 1.2; margin-left: 12px; margin-right: 12px;overflow: hidden;" data-cy="recent-patient-details">
              <div style="font-size: 14px; font-weight: 500;" data-cy="recent-patient-name">
                {{getName(appt)}}
              </div>
              @if (isPrivateInfoVisible) {
                <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-contact">
                  {{getContact(appt)}}
                </div>
              }
              @if (isPrivateInfoVisible) {
                <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-address">
                  {{getAddress(appt)}}
                </div>
              }
              @if (!isPrivateInfoVisible) {
                <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-contact">
                  *******
                </div>
              }
              @if (!isPrivateInfoVisible) {
                <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-address">
                  *******
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
